import { Component, OnInit, ViewChild } from '@angular/core';
import { CaseComponent } from '../../components/case-base/case.component';
import { CaseService } from '@app/core/services/case.service';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { SelectComponentOptions } from '@app/shared/components/select/base-select-with-id.component';
import {
  AddressParticipantComponent,
  AddressParticipantOptions
} from '@app/modules/case/components/address-participant/address-participant.component';
import { PatchValue } from '@app/shared/components/base/base-patch.component';
import { ParticipantTypes } from '@app/shared/models/participant-type';
import { CaseParticipantUriBuilderParams } from '@app/core/services/participants.service';

@Component({
  templateUrl: './case-detailed-vehicle.component.html',
  styleUrls: ['./case-detailed-vehicle.component.scss']
})
export class CaseDetailedVehicleComponent extends CaseComponent
                                          implements OnInit {

  @ViewChild('addressParticipant') addressParticipantComponent: AddressParticipantComponent;

  public vehicleTypeSelectOptions: SelectComponentOptions;
  public manufacturerSelectOptions: SelectComponentOptions;
  public participantTypeOptions: SelectComponentOptions;
  public excludedParticipantTypes: string[];
  public addressParticipantOptions: AddressParticipantOptions[];
  public participantTypeUriBuilderParams: CaseParticipantUriBuilderParams;

  public readonly participantTypeVehicleLocation = ParticipantTypes.VEHICLE_LOCATION.key;

  constructor(protected componentServiceBundle: ComponentServiceBundle,
              protected caseService: CaseService) {
    super(componentServiceBundle, caseService);
    this._idPrefix = 'case_detailed_vehicle.';
  }

  public ngOnInit() {
    super.ngOnInit();

    this.vehicleTypeSelectOptions = {
      label: 'vehicle.type',
      class: 'full-width',
      patchPath: 'vehicle.type',
      uriParams: {
        urlSuffix: 'types'
      }
    };

    this.manufacturerSelectOptions = {
      label: 'vehicle.manufacturer',
      class: 'full-width',
      patchPath: 'vehicle.manufacturer',
      uriParams: {
        urlSuffix: 'manufacturers'
      }
    };

    this.participantTypeOptions = {
      patchPath: 'vehicle.location',
      label: 'vehicle.location'
    };

    this.excludedParticipantTypes = [ParticipantTypes.VEHICLE_LOCATION.key];

    this.addressParticipantOptions = [
      AddressParticipantOptions.NAME,
      AddressParticipantOptions.MULTI_NAMES,
      AddressParticipantOptions.ADDRESS,
      AddressParticipantOptions.COUNTRY
    ];

    this.participantTypeUriBuilderParams = new CaseParticipantUriBuilderParams(this.id);
  }

  public updateVehicleLocation(patchValue: PatchValue): void {
    this.patchAndUpdateWithValue(patchValue, () => {
      this.addressParticipantComponent.getOriginal();
    });
  }

}
